export default __webpack_public_path__ + "static/media/PenguinSmart_Logo_BIL_TCN_Vertical_Black.ef752858.jpg";